import { LogisticSettings } from '../domain'
import LogisticRepository from '../infrastructure/logistic.repository'

export default class SetLogisticSettings {
  private readonly repository: LogisticRepository

  constructor(repository: LogisticRepository) {
    this.repository = repository
  }

  async execute(sellerId: string, settings: LogisticSettings): Promise<void> {
    await this.repository.setSettings(sellerId, settings)
  }
}
